import type { SyntheticEvent } from "react";

/** Shared filters for recorder media lists (RecordingsPopup / Gallery / Telegram picker). */

export function isVideoFile(name: string): boolean {
    return name.toLowerCase().endsWith(".mp4");
}

export function isPhotoFile(name: string): boolean {
    return /\.(jpe?g)$/i.test(name);
}

export function formatBytes(n: number): string {
    if (!Number.isFinite(n)) return "—";
    if (n < 1024) return `${n} B`;
    if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
    return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

export function preventGalleryContextMenu(e: SyntheticEvent) {
    e.preventDefault();
}

export function triggerBrowserDownload(blob: Blob, filename: string) {
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = filename;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
}
